import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import CookieConsent from "react-cookie-consent"
import Header from '../components/header'
import Footer from '../components/footer'
import '../styles/main.scss'

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: 'Maßgeschneiderte Software für Ihr Unternehmen. Qualität aus Oberösterreich.' },
        { name: 'keywords', content: 'software engineering, oberösterreich, website, webapplikation, anwendungssoftware, elixir, java, c#, react' },
        { name: 'google-site-verification', content: 'RAeRVbJpKuMC5zGdH2-81WRsZ9OVjYBTiVzWYM01Kok' },
      ]}>
      <html lang="de" />
    </Helmet>
    <Header siteTitle={data.site.siteMetadata.title} />
    <main className="h-100">
    {children()}
    </main>
    <Footer />
    <CookieConsent
      location="bottom"
      buttonText="Akzeptieren"
      style={{ background: "#262699", fontSize: "15px" }}
      buttonStyle={{ background: "#FDFFFC", padding: "1px 7px 2px" }}>
      Wir verwenden Cookies um die Webseite möglichst benutzerfreundlich zu gestalten. 
      Durch die Nutzung unserer Webseite erklären Sie sich damit einverstanden, dass wir Cookies setzen.
      {' '}<Link to="/datenschutz" className="text-white border-bottom">Mehr erfahren.</Link>
    </CookieConsent>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js